import LandingPageLayout from 'components/layout/landing/LandingPageLayout';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import TermsConditions from 'screens/LandingPages/TermsConditions';

function TermsConditionsPage(props) {
  return (
    <TermsConditions {...props} />
  );
}

TermsConditionsPage.getLayout = (page, props) => (
  <LandingPageLayout
    title='OnBoard Crew App | Portal Karier Terbaik untuk Pelaut'
    description='Temukan lowongan kerja pelaut terbaru di portal kerja khusus pelaut. Daftar sekarang untuk melamar pekerjaan di kapal pesiar, kapal kargo, kapal tanker, dan lainnya.'
    keywords='lowongan pelaut, kerja di kapal, job pelaut, lowongan kerja pelaut, portal kerja maritim, pekerjaan pelaut, lowongan kapal pesiar, lowongan kapal kargo, karier di laut, pekerjaan di kapal'
    {...props}
  >
    {page}
  </LandingPageLayout>
);

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
    },
  };
}

export default TermsConditionsPage;
